import { render, staticRenderFns } from "./CookiePreferences.vue?vue&type=template&id=25b110d8&scoped=true"
import script from "./CookiePreferences.vue?vue&type=script&lang=js"
export * from "./CookiePreferences.vue?vue&type=script&lang=js"
import style0 from "./CookiePreferences.vue?vue&type=style&index=0&id=25b110d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25b110d8",
  null
  
)

export default component.exports